import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import AdminPage from './AdminPage.js';

export default WithGASetup(AdminPage, AuthContext);
